module.exports = "/_next/static/images/d6e6f86cfd50fc6d39c89f9d598f9284-young-people-walking@0.75x.jpg";